import axios, { AxiosHeaders } from 'axios';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../../lib/apiClient';
import { metabaseInstanceUrl } from '../constants';

export const METABASE_API_URL = `${metabaseInstanceUrl}/api`;
const METABASE_SESSION_TOKEN = 'metabaseSessionToken';
const SSO_URL = `${metabaseInstanceUrl}/auth/sso`;

const getMetabaseSessionToken = () =>
  localStorage.getItem(METABASE_SESSION_TOKEN);

export const setMetabaseSessionToken = (token: string) =>
  localStorage.setItem(METABASE_SESSION_TOKEN, token);

export const metabaseApi = axios.create({
  baseURL: `${METABASE_API_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

metabaseApi.interceptors.request.use(config => {
  const token = getMetabaseSessionToken();

  if (!token) {
    return config;
  }

  const headers = AxiosHeaders.from(config.headers);
  headers.set('X-Metabase-Session', token);

  return {
    ...config,
    headers,
  };
});

export const getMetabaseSessionTokenViaSsoFlow = async () => {
  const response = await api.request(endpoints.internal.getMetabaseJWT());

  const jwtToken = response.jwt;
  if (!jwtToken) {
    throw new Error('JWT_TOKEN not found for Metabase SSO flow.');
  }

  // This flow needs to use a clean axios instance without interceptors
  // to avoid circular dependencies if the SSO call itself fails.
  const tempApi = axios.create({
    baseURL: `${METABASE_API_URL}`,
  });

  const { data } = await tempApi.get(SSO_URL, {
    headers: { 'x-metabase-client': 'embedding-sdk-react' },
    params: { preferred_method: 'jwt' },
  });

  const {
    data: { id },
  } = await tempApi.get(SSO_URL, {
    params: { jwt: jwtToken },
    headers: {
      'x-metabase-client': 'embedding-sdk-react',
      'x-metabase-sdk-jwt-hash': data.hash,
    },
  });

  if (!id) {
    throw new Error('Failed to retrieve Metabase session ID.');
  }

  return id as string;
};
